export const ADMIN_TABLE_VIEWPORT_OFFSET_PX = 250;
export const ADMIN_TABLE_STORICO_VIEWPORT_OFFSET_PX = 280;

export const adminScrollLayoutOuterBaseSx = {
  width: "100%",
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

function fullscreenTableDimensions(offsetPx) {
  const h = `calc(100vh - ${offsetPx}px)`;
  return {
    maxHeight: h,
    height: h,
    minHeight: 650,
  };
}

export function adminListTableContainerSx(loading) {
  return {
    ...fullscreenTableDimensions(ADMIN_TABLE_VIEWPORT_OFFSET_PX),
    borderRadius: 2,
    border: "1px solid #e6ebf3",
    backgroundColor: "white",
    ...adminScrollLayoutOuterBaseSx,
    opacity: loading ? 0.6 : 1,
    transition: "opacity 0.3s",
  };
}

export const adminFullscreenTableInPaperSx = {
  ...fullscreenTableDimensions(ADMIN_TABLE_VIEWPORT_OFFSET_PX),
  ...adminScrollLayoutOuterBaseSx,
  backgroundColor: "white",
};

export const adminCategoryDesktopPaperSx = {
  borderRadius: 3,
  boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
  ...fullscreenTableDimensions(ADMIN_TABLE_VIEWPORT_OFFSET_PX),
  ...adminScrollLayoutOuterBaseSx,
  backgroundColor: "white",
};

export const adminStoricoListTableContainerSx = {
  ...fullscreenTableDimensions(ADMIN_TABLE_STORICO_VIEWPORT_OFFSET_PX),
  borderRadius: 2,
  border: "1px solid #e0e0e0",
  backgroundColor: "white",
  ...adminScrollLayoutOuterBaseSx,
};

export const adminEmbeddedTableBodyMaxHeight = "min(420px, 55vh)";

export const adminEmbeddedTablePaperSx = {
  borderRadius: 2,
  overflow: "hidden",
};

export const ADMIN_TABLE_HEADER_BG = "#0b3d87";

const adminDataTableHeadCellSx = {
  backgroundColor: `${ADMIN_TABLE_HEADER_BG} !important`,
  backgroundImage: "linear-gradient(180deg, #0e4a9e 0%, #0b3d87 100%)",
  color: "white !important",
  border: "none !important",
  boxShadow: "none !important",
  fontWeight: 700,
  fontSize: "0.72rem",
  letterSpacing: "0.05em",
  textTransform: "uppercase",
};

export const adminDataTableHeadSx = {
  backgroundColor: ADMIN_TABLE_HEADER_BG,
  "& .MuiTableCell-head": adminDataTableHeadCellSx,
  "& .MuiTableRow-head": {
    border: "none !important",
  },
};

export const adminDataTableHeadSmallSx = {
  ...adminDataTableHeadSx,
  "& .MuiTableCell-head": {
    ...adminDataTableHeadCellSx,
    fontWeight: 700,
    py: 1.5,
  },
};

// --- Stile "fuso" ricerca + header + tabella, agganciato alla finestra (vedi GestioneEcommerce) ---

// Barra filtri fusa all'header: angoli alti arrotondati, bassi squadrati, bordo inferiore assente.
export function mergedFilterPaperSx(isSticky) {
  return {
    position: { xs: "sticky", md: "static" },
    top: { xs: 15, md: "auto" },
    zIndex: { xs: 1100, md: "auto" },
    mb: 0,
    width: "100%",
    mx: { xs: 1, md: 0 },
    borderTopLeftRadius: { xs: "32px", md: 16 },
    borderTopRightRadius: { xs: "32px", md: 16 },
    borderBottomLeftRadius: { xs: "32px", md: 0 },
    borderBottomRightRadius: { xs: "32px", md: 0 },
    border: { xs: "1px solid rgba(255, 255, 255, 0.4)", md: "1px solid #e2e8f0" },
    borderBottom: { md: "none" },
    background: {
      xs: "linear-gradient(135deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.5) 100%)",
      md: "#ffffff",
    },
    boxShadow: {
      xs: "0 8px 32px 0 rgba(31, 38, 135, 0.08)",
      md: isSticky
        ? "-30px -30px 40px 10px rgba(255, 255, 255, 1), 30px -30px 40px 10px rgba(255, 255, 255, 1), 0 -40px 40px 15px rgba(255, 255, 255, 1), 0 -8px 20px -12px rgba(15, 23, 42, 0.12), 12px 0 20px -16px rgba(15, 23, 42, 0.12), -12px 0 20px -16px rgba(15, 23, 42, 0.12)"
        : "0 -8px 20px -12px rgba(15, 23, 42, 0.12), 12px 0 20px -16px rgba(15, 23, 42, 0.12), -12px 0 20px -16px rgba(15, 23, 42, 0.12)",
    },
    transition: isSticky ? "none" : "box-shadow 0.4s ease-out, border-radius 0.4s ease-out",
    backdropFilter: { xs: "blur(20px) saturate(180%)", md: "none" },
    WebkitBackdropFilter: { xs: "blur(20px) saturate(180%)", md: "none" },
  };
}

// Contenitore tabella senza scroll interno: angoli bassi arrotondati e ombre laterali/inferiori.
export function mergedTableContainerSx(tableLoading) {
  return {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 12,
    borderBottomRightRadius: 12,
    border: "1px solid #e2e8f0",
    backgroundColor: "white",
    boxShadow:
      "12px 0 20px -16px rgba(15, 23, 42, 0.14), -12px 0 20px -16px rgba(15, 23, 42, 0.14), 0 18px 28px -18px rgba(15, 23, 42, 0.20)",
    overflow: "visible",
    opacity: tableLoading ? 0.6 : 1,
    transition: "opacity 0.3s",
    boxSizing: "border-box",
  };
}

// Intestazione sticky agganciata alla finestra a quota headerTop (sotto la barra filtri).
export function mergedTableHeadSx(headerTop = 0) {
  return {
    ...adminDataTableHeadSx,
    "& .MuiTableCell-head": {
      ...adminDataTableHeadSx["& .MuiTableCell-head"],
      top: { xs: 0, md: headerTop },
      zIndex: 3,
      py: 1.75,
      whiteSpace: "nowrap",
      backgroundColor: "#0b3d87 !important",
      boxShadow: "0 6px 10px -6px rgba(15, 23, 42, 0.35) !important",
    },
  };
}

// Riga del corpo: striping pari/dispari, hover, selezione brandizzata e celle coerenti.
export function mergedTableRowSx(index) {
  return {
    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9fbfe",
    transition: "background-color 0.18s ease",
    "&:hover": { backgroundColor: "#eef3fc" },
    "& td": {
      borderBottom: "1px solid #eef2f7",
      py: 1.35,
      fontSize: "0.82rem",
      color: "#0f172a",
    },
    "&:last-of-type td": { borderBottom: "none" },
    // Riga selezionata: tinta navy tenue + accento verticale a sinistra
    "&.Mui-selected, &.Mui-selected:hover": { backgroundColor: "#e8f0fd" },
    "&.Mui-selected td:first-of-type": { boxShadow: "inset 3px 0 0 #0b3d87" },
  };
}
 